import { Color, Radius } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Color.calmGrey,
    borderRadius: Radius.M,
    overflow: 'hidden',
  },
})

interface Props extends ViewProps {}
const Card = (props: Props) => {
  const { style, children, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {children}
    </View>
  )
}

export default Card
